import { render, staticRenderFns } from "./MailEditor.vue?vue&type=template&id=03d827c2&scoped=true&"
import script from "./MailEditor.vue?vue&type=script&lang=js&"
export * from "./MailEditor.vue?vue&type=script&lang=js&"
import style0 from "./MailEditor.vue?vue&type=style&index=0&id=03d827c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d827c2",
  null
  
)

export default component.exports